import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const DebitCard = ({ values }) => (
  <Content>
    {({ debitCardTitle, debitCardSubTitle, radioFieldYes = '', radioFieldNo = '' }) => (
      <div>
        <Field name="debitCard" subscription={{ touched: true, error: true }}>
          {({ input }) => (
            <GenericFieldWrapper
              inputId="debitCard"
              title={debitCardTitle}
              description={debitCardSubTitle}
            >
              <GenericRadio.InlineSet
                groupName="debitCard-group"
                items={[
                  { id: radioFieldYes, labelText: radioFieldYes },
                  { id: radioFieldNo, labelText: radioFieldNo }
                ]}
                {...input}
                selectedId={values.debitCard}
              />
            </GenericFieldWrapper>
          )}
        </Field>
      </div>
    )}
  </Content>
);

export default DebitCard;
